<template>
  <div class="dialog">
    <el-dialog title="学生学习生活经历" :visible.sync="lifeExperienceShow" width="750px" :before-close="dialogClose"
      @open="dialogOpen">
      <el-checkbox v-model="checked" label="经历1" border></el-checkbox>
      <el-checkbox v-model="checked" label="经历2" border></el-checkbox>
      <div class="form-btn">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'lifeExperienceShow'
  ],
  data() {
    return {
      checked: true
    };
  },
  methods: {
    // 开启弹窗
    dialogOpen() {
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:lifeExperienceShow", false);
    },
    confirm() {
      
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./lifeExperienceDialog.scss";
</style>